import { render, staticRenderFns } from "./Alport.vue?vue&type=template&id=0feffb22"
import script from "./Alport.vue?vue&type=script&lang=js"
export * from "./Alport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports